import Vue from "vue";
import VueRouter from "vue-router";
import { auth } from "../utils/firebase";
import revisionHandler from "../utils/revisionHandler";

Vue.use(VueRouter);



const routes = [
  {
    path: "/admin/freeBundles",
    name: "Free Bundles",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/FreeBundles"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/adminChat",
    name: "Admin Chat",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/AdminChat"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/marketingProjects",
    name: "Marketing Projects",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/MarketingProjects"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/adminUsers",
    name: "Admin Users",
    component: () =>
      import(/* webpackChunkName: "admin-users" */ "../views/AdminUsers"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/adminStats",
    name: "Admin Stats",
    component: () =>
      import(/* webpackChunkName: "admin-stats" */ "../views/AdminStats"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/adminChat/:id",
    name: "Admin Chat",
    component: () =>
      import(/* webpackChunkName: "admin-chat" */ "../views/AdminChat"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/FestivalHome"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/festival",
    name: "Festival",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/FestivalHome"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/FestivalHome"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/schedule",
    name: "Schedule",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "schedule" */ "../views/Schedule.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/session/:slug",
    name: "Session",
    component: () =>
      import(/* webpackChunkName: "session" */ "../views/Session.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/topic/:id",
    name: "Topic",
    component: () =>
      import(/* webpackChunkName: "topic" */ "../views/Topic.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/live2",
    name: "Live Old",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "live" */ "../views/Live.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/live",
    name: "Live2",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "live-fb" */ "../views/LiveFB.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/userProjects",
    name: "User Projects",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "user-projects" */ "../views/UserProjects.vue"
      ),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/project/:sanityProjectId",
    name: "Project",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "project" */ "../views/Project.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/auth",
    name: "Auth",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "auth" */ "../views/Auth.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/share",
    name: "Share",
    component: () =>
      import(/* webpackChunkName: "share" */ "../views/Share.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/social",
    name: "Social",
    component: () =>
      import(/* webpackChunkName: "social" */ "../views/Social.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/speakers",
    name: "Speakers",
    component: () =>
      import(/* webpackChunkName: "speakers" */ "../views/Speakers.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/partners",
    name: "Partners",
    component: () =>
        import(/* webpackChunkName: "speakers" */ "../views/Partners.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/speaker/:id",
    name: "Speaker",
    component: () =>
      import(/* webpackChunkName: "speaker" */ "../views/Speaker.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/partner/:id",
    name: "Partner",
    component: () =>
        import(/* webpackChunkName: "speaker" */ "../views/Partner.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "loginView" */ "../views/LoginView"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/postLogin",
    name: "PostLogin",
    component: () =>
      import(/* webpackChunkName: "postLogin" */ "../views/PostLogin"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/recaptcha",
    name: "RecaptchaTest",
    component: () =>
      import(/* webpackChunkName: "recaptchaTest" */ "../views/RecaptchTest"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/purchase",
    name: "Purchase",
    component: () =>
      import(/* webpackChunkName: "purchase" */ "../views/Purchase"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/team",
    name: "Team",
    component: () => import(/* webpackChunkName: "team" */ "../views/Team"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/tour",
    name: "Tour",
    component: () => import(/* webpackChunkName: "tour" */ "../views/Tour"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/Privacy"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/purchaseConfirmation",
    name: "PurchaseConfirmation",
    component: () =>
      import(
        /* webpackChunkName: "purchaseConfirmation" */ "../views/PurchaseConfirmation"
      ),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/updateDisplayName",
    name: "UpdateDisplayName",
    component: () =>
      import(
        /* webpackChunkName: "updateDisplayName" */ "../views/UpdateDisplayName"
      ),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/topicApproval",
    name: "TopicApproval",
    component: () =>
      import(/* webpackChunkName: "topicApproval" */ "../views/TopicApproval"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/whatsIncluded",
    name: "WhatsIncluded",
    component: () =>
      import(/* webpackChunkName: "whatsIncluded" */ "../views/WhatsIncluded"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/generateLoginLink",
    name: "GenerateLoginLink",
    component: () =>
      import(/* webpackChunkName: "generateLoginLink" */ "../views/AdminLogin"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/faq",
    name: "Faq",
    component: () => import(/* webpackChunkName: "faq" */ "../views/Faqs"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/previous",
    name: "Past Events",
    component: () =>
      import(/* webpackChunkName: "faq" */ "../views/PastEvents"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/updateLiveView",
    name: "Refresh Live View",
    component: () =>
      import(
        /* webpackChunkName: "refresh-live-view" */ "../views/UpdateLiveView.vue"
      ),
    meta: {
      noAuth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = !to.matched.some(record => record.meta.noAuth);
  if (requiresAuth && !(await auth.currentUser)) {
    next("/");
  } else {
    window.scrollTo(0, 0);
    next();
  }
});

router.onError(error => {
  console.error(error);
  revisionHandler();
});

export default router;
